import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'tf-shared-list-info-modal',
    templateUrl: './tf-shared-list-info-modal.component.html',
    styleUrls: ['./tf-shared-list-info-modal.component.scss']
})
export class TfSharedListInfoModalComponent implements OnInit {

    constructor(
        private ngbActiveModal: NgbActiveModal
    ) {
    }

    ngOnInit(): void {
        this.showSlides();
    }

    slideIndex = 0;

    showSlides(): void {
        let i = 0;
        const slides: any = document.getElementsByClassName("save-to-list-item");
        const dots = document.getElementsByClassName("bullet");

        for (i = 0; i < slides.length; i++) {
            slides[i].style.display = "none";
        }
        this.slideIndex++;
        if (this.slideIndex > slides.length) {
            this.slideIndex = 1;
        }
        for (i = 0; i < dots.length; i++) {
            dots[i].className = dots[i].className.replace(" active", "");
        }
        if (typeof slides[this.slideIndex - 1] !== 'undefined') {
            slides[this.slideIndex - 1].style.display = "block";
            dots[this.slideIndex - 1].className += " active";
            setTimeout(() => this.showSlides(), 5000);
        }

    }

    closeModal(): void {
        this.ngbActiveModal.close("closed");
    }

    dismissModal(): void {
        this.ngbActiveModal.dismiss("dismissed");
    }
}
